import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Config } from '../config';

const Login = () => {
  const config = new Config();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [credentialsMatch, setcredentialsMatch] = useState(false);
  const navigate = useNavigate();


  const handleLogin = (uname: string, pwd: string) => {
    if (uname === config.settings.username && pwd === config.settings.password) {
      setCookie('loginDetails', JSON.stringify({ username: uname, password: pwd }), 1);
      navigate('/featuresView');
    } else {
      setcredentialsMatch(true);
    }
  };

 

  const setCookie = (name: string, value: string, daysUntilExpire: number = 1) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + daysUntilExpire * 24 * 60 * 60 * 1000);
    const cookieValue = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/';
    document.cookie = cookieValue;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleLogin(username, password);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Login</h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div className='mb-3'>
              <label htmlFor="username" className="sr-only">Username</label>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                className="relative block w-full px-3 py-2 border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className='mb-3'>
              <label htmlFor="password" className="sr-only">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="relative block w-full px-3 py-2 border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="flex justify-between items-center">
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Log in
            </button>  
          </div>
           {credentialsMatch && 
           <div className='text-red-600'> Username or password is incorrect</div>
           }     
        </form>
      </div>
    </div>
  );
};

export default Login;
